import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Llegás a una primera sesión sin protocolo claro',
    costo: 'Una oportunidad de intervención temprana perdida'
  }, {
    sin: 'Buscás planillas en internet en inglés',
    costo: 'Horas de trabajo por semana que podrían ir a la atención'
  }, {
    sin: 'El informe de Obra Social se hace a último momento',
    costo: 'Riesgo de rechazo y corte de prestación'
  }, {
    sin: 'El AT improvisa porque no tiene protocolo',
    costo: 'El progreso del niño se frena por inconsistencia del equipo'
  }, {
    sin: 'La familia no sabe cómo acompañar en casa',
    costo: 'Las 23 horas fuera de sesión trabajan en contra'
  }, {
    sin: 'No tenés análisis funcional de las conductas',
    costo: 'Intervenciones que atacan el síntoma, no la causa'
  }, {
    sin: 'Sin sistema de registro',
    costo: 'Decisiones clínicas basadas en intuición, no en datos'
  }];
  return <section className="py-20 bg-slate-950 text-white" data-id="element-46">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-49">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-50">
          <div className="min-w-[600px]" data-id="element-51">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-52">
              <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-53">
                Sin CentralPack
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-54">
                Costo real
              </div>
            </div>

            <div className="space-y-2" data-id="element-55">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-slate-900/60 rounded-xl p-4 items-center border border-slate-800" data-id="element-56">
                  <div className="text-slate-300 font-medium" data-id="element-57">{row.sin}</div>
                  <div className="text-red-300 font-medium" data-id="element-58">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-slate-500 mt-4 md:hidden" data-id="element-59">
            ← Scroll to see full table →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-cyan-700 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-60">
          <p className="md:text-2xl font-medium text-cyan-100 mb-4 text-[16px]" data-id="element-61">
            El próximo paciente que llegue puede encontrar un profesional
            diferente.
          </p>
          <p className="md:text-4xl font-black text-white text-[20px]" data-id="element-62">
            "La próxima sesión, vas a llegar con sistema." 🧠🇦🇷
          </p>
        </motion.div>
      </div>
    </section>;
}